import { render, staticRenderFns } from "./qtyChangeLog.vue?vue&type=template&id=1828e1f0&scoped=true"
import script from "./qtyChangeLog.vue?vue&type=script&lang=js"
export * from "./qtyChangeLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1828e1f0",
  null
  
)

export default component.exports